import { useTranslation } from "react-i18next";
import { cn } from "@/shared/lib/utils";
import type { TosState } from "./compliance-types";

const VARIANT_CLASS: Record<TosState, string> = {
  // Brand-orange = the affirmative, canonical state.
  ACTIVE: "bg-wander-orange/15 text-wander-orange ring-wander-orange/40",
  // Neutral gray = not yet visible to users, no urgency tint.
  DRAFT: "bg-wander-gray/15 text-wander-gray ring-wander-gray/40",
  // Orange ring on neutral = "live, but has a scheduled end date".
  SCHEDULED_RETIRE: "bg-wander-orange/5 text-wander-black ring-wander-orange/50",
  // Black on light gray = "this is history, don't act on it".
  RETIRED: "bg-wander-gray/10 text-wander-black ring-wander-gray/30",
};

interface StatusBadgeProps {
  readonly state: TosState;
  readonly className?: string;
}

export function StatusBadge({ state, className }: StatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      data-testid={`compliance-status-${state.toLowerCase()}`}
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset",
        VARIANT_CLASS[state],
        className,
      )}
    >
      {t(`compliance.status.${state}`)}
    </span>
  );
}
